import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { BusinessHour } from '../../stores/BranchStore';
import { BranchOpenTime } from './BranchOpenTime';

interface BranchBusinessHoursProps {
  businessHours?: BusinessHour[];
}

export const BranchBusinessHours = observer((props: BranchBusinessHoursProps) => {
  const { businessHours } = props;
  const { translate } = React.useContext(TranslationsContext);

  const commaWhenNotLast = (index: number) => {
    return businessHours.length - index > 1 ? ', ' : '';
  };

  return (
    <>
      {businessHours &&
        businessHours.map((hour, index) => {
          return (
            <span key={index}>
              <strong>
                {translate(`branch.openDay_${hour.startDay}`)}
                {hour.startDay !== hour.endDay && <span>-{translate(`branch.openDay_${hour.endDay}`)}</span>}
              </strong>
              <BranchOpenTime hour={hour} displayOpenText={false} />
              <strong>{commaWhenNotLast(index)}</strong>
            </span>
          );
        })}
    </>
  );
});
